import GetZbooniPopover from "app/components/get-zbooni-popover";
import Sprite from "app/components/sprite";
import { ZBNI_CUSTOMER_SUPPORT } from "app/config/constants";
import appleLogo from "app/images/who-we-serve/apple-logo.png";
import googleplayLogo from "app/images/who-we-serve/google-play-logo.png";
import cardPower from "app/images/who-we-serve/power-card-img.png";
import cardStarter from "app/images/who-we-serve/starter-card-img.png";
import { Trans } from "react-i18next";
import { ChartSwiper } from "app/sections/who-we-serve/charts-swiper";
import { useState } from "react";

export const ExpandIntoUntappedSection = () => {
  const [popover, setPopover] = useState(false);

  const zbooniLink = `${ZBNI_CUSTOMER_SUPPORT}&text=Hello%21%20I%20am%20interested%20in%20learning%20more%20about%20Zbooni.%20I%20already%20have%20an%20established%20business%2C%20and%20would%20like%20to%20know%20how%20Zbooni%20can%20help%20me%20drive%20more%20sales%20with%20cCommerce.`;

  return (
    <section
      className="relative m-auto
      w-full font-montserrat text-white"
      style={{
        background: "linear-gradient(180deg, #101820 55%, #ffffff 45%)",
      }}
    >
      <GetZbooniPopover
        popover={popover}
        setPopover={setPopover}
        zbooniLink={zbooniLink}
      />
      <Sprite
        className="absolute top-32 h-[239px] w-[495px] 
        ltr:right-0 rtl:left-0 rtl:scale-x-[-1]"
        name="expand-into-vector"
      />
      <div className="zbooni-layout flex h-full flex-col content-evenly">
        <h3
          className="mb-28 max-w-xl font-montserrat
          text-2xl font-bold text-white xxs:pt-24
          xxs:text-xl xs:pt-32 xs:text-[22px] lg:pt-40"
        >
          <Trans>Thousands of businesses sell more with Zbooni.</Trans>
        </h3>
      </div>
      <div
        className="xl:relative xl:flex-row xl:justify-center 
				xl:overflow-hidden"
      >
        <div className="lg:px-32 xl:mx-auto xl:max-w-[90rem] xl:px-20">
          <ChartSwiper />
        </div>
      </div>
      <div
        className="zbooni-layout mt-[52px] flex h-full
        flex-col content-evenly lg:mt-[72px]"
      >
        <div className="mb-8 flex flex-wrap justify-evenly">
          <div
            className="rounded-2xl bg-white text-primary shadow-lg
            xxs:mb-7 xxs:w-[327px] xxs:px-5 xxs:py-4 md:w-[500px] lg:mb-6
            lg:w-[580px] lg:p-7"
          >
            <h2
              className="m-0 font-montserrat
              text-3xl font-bold xxs:text-xl xs:text-2xl"
            >
              <Trans>Starter</Trans>
            </h2>
            <p className="text-base xxs:mb-4 lg:mb-5">
              <Trans>Get a head start.</Trans>
            </p>
            <img className="rounded-2xl" src={cardStarter} alt="" />
            <p className="my-5 leading-relaxed xxs:text-xs lg:text-sm">
              <Trans>
                If you’re just getting started, or still in the early phase, you
                have plenty to worry about. Establishing an online presence,
                choosing the right products to sell, and sorting out how to
                accept payments. It’s hard. It’s technical. It’s overwhelming.
                It doesn’t have to be.
              </Trans>
            </p>
            <div className="flex items-center">
              <div
                className="h-[38px] w-2 rounded bg-gradient-to-br 
                from-yellowgreen to-green-dark ltr:mr-3 rtl:ml-3 md:w-[5px]"
              />
              <p className="py-4 xxs:text-xs lg:text-sm">
                <Trans>
                  Our mission is to remove the headaches so you can focus on
                  what you do best.
                </Trans>
              </p>
            </div>
            <span className="block h-px w-full bg-gray-200" />
            <div className="">
              <h4
                className="center text-center font-montserrat text-xl
                font-bold xxs:my-4 xxs:text-base xs:text-base lg:my-7"
              >
                <Trans>Get started in minutes</Trans>
              </h4>
              <div
                className="text-18px flex flex-row items-baseline
                justify-between xxs:mb-5 xxs:ml-[-25px]
                xxs:mr-[-25px] xxs:px-0 xs:px-0 lg:mb-9 lg:px-12"
              >
                <div
                  className="mx-auto flex flex-col items-center text-center 
                  text-xs font-medium lg:text-sm"
                >
                  <Sprite name="start-selling" className="mb-2 h-10 w-9" />
                  <Trans>Start selling</Trans>
                  <br />
                  <Trans>online.</Trans>
                </div>
                <div
                  className="-ml-3 -mr-3 flex flex-col items-center text-center
                  text-xs font-medium lg:text-sm"
                >
                  <Sprite name="access-resources" className="mb-2 h-11 w-7" />
                  <Trans>Access resources to</Trans>
                  <br />
                  <Trans>power your business.</Trans>
                </div>
                <div
                  className="mx-auto flex flex-col items-center text-center 
                  text-xs font-medium lg:text-sm"
                >
                  <Sprite name="accept-payments" className="mb-2 h-8 w-12" />
                  <Trans>Accept</Trans>
                  <br />
                  <Trans>payments.</Trans>
                </div>
              </div>
              <div
                className="flex flex-col items-center justify-between px-2 
                text-base font-bold text-white md:flex-row lg:px-6"
              >
                <a
                  href="https://apps.apple.com/ae/app/zbooni/id1222835796"
                  target="_blank"
                  rel="noreferrer"
                  id="cta_whoWeServe_expandIntoUntapped_downloadNow"
                >
                  <button
                    className="mx-2 my-1 flex items-center justify-center 
                    rounded-3xl bg-primary py-2 xxs:w-[250px] xs:w-[250px]
                    md:w-[200px] md:px-4 md:py-3 lg:w-[215px] lg:px-6"
                  >
                    <img
                      src={appleLogo}
                      className="w-4 ltr:mr-3 rtl:ml-3"
                      alt=""
                    />
                    <p
                      className="text-[13px] font-bold lg:text-base
                      lg:font-extrabold"
                    >
                      <Trans>Download now</Trans>
                    </p>
                  </button>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.zbooni&hl=en&gl=US"
                  target="_blank"
                  rel="noreferrer"
                  id="cta_whoWeServe_expandIntoUntapped_downloadNow"
                >
                  <button
                    className="mx-2 my-1 flex items-center justify-center 
                    rounded-3xl bg-primary py-2 xxs:w-[250px] xs:w-[250px]
                    md:w-[200px] md:px-4 md:py-3 lg:w-[215px] lg:px-6"
                  >
                    <img
                      src={googleplayLogo}
                      className="w-4 ltr:mr-3 rtl:ml-3"
                      alt=""
                    />
                    <p
                      className="text-[13px] font-bold lg:text-base
                      lg:font-extrabold"
                    >
                      <Trans>Download now</Trans>
                    </p>
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            className="rounded-2xl bg-white text-primary
            shadow-lg xxs:w-[327px] xxs:px-5 xxs:py-4 md:w-[500px]
            lg:mb-6 lg:w-[580px] lg:p-7"
          >
            <h2
              className="m-0 font-montserrat
              text-3xl font-bold xxs:text-xl xs:text-2xl"
            >
              <Trans>Power</Trans>
            </h2>
            <p className="text-base xxs:mb-4 lg:mb-5">
              <Trans>Take your business to the next level.</Trans>
            </p>
            <img className="rounded-2xl" src={cardPower} alt="" />
            <p
              className="my-5 hidden text-xs
              leading-relaxed tracking-[-0.01em] lg:text-sm xl:block"
            >
              <Trans>
                Already selling with eCommerce, or have a retail presence?
              </Trans>
            </p>
            <p
              className="my-5 hidden text-xs
              leading-relaxed tracking-[-0.01em] lg:text-sm xl:block"
            >
              <Trans>
                Complement your existing operation with a new channel to drive
                more sales and make the most of what you have going.
              </Trans>
            </p>
            <p
              className="my-5 block text-xs
              leading-relaxed tracking-[-0.01em] lg:text-sm xl:hidden"
            >
              <Trans>
                Already selling with eCommerce, or have a retail presence?
                Complement your existing operation with a new channel to drive
                more sales and make the most of what you have going.
              </Trans>
            </p>
            <div className="flex items-center">
              <div
                className="mt-1 h-16 w-3 rounded 
                bg-gradient-to-br from-yellowgreen to-green-dark
                ltr:mr-3 rtl:ml-3 md:h-10 md:w-[9px]"
              />
              <p className="py-4 xxs:text-xs lg:text-sm">
                <Trans>
                  Meet your customers on their favorite messaging and social
                  apps, generate new business and convert more sales with
                  cCommerce.
                </Trans>
              </p>
            </div>
            <span className="block h-px w-full bg-gray-200" />
            <div className="px-7 xxs:px-0">
              <h4
                className="center text-20px text-center font-montserrat
                font-bold xxs:my-4 xxs:text-base xs:text-base lg:my-7"
              >
                <Trans>Scale up effortlessly</Trans>
              </h4>
              <div
                className="text-18px flex items-baseline
                justify-between xxs:mb-5 xxs:ml-[-23px]
                xxs:mr-[-23px] xxs:px-0 xs:px-0 lg:mb-9 lg:px-12"
              >
                <div
                  className="mx-auto flex flex-col
                  items-center text-center text-xs font-medium lg:text-sm"
                >
                  <Sprite name="new-ways" className="mb-2 h-12 w-14" />
                  <Trans>Accept payments in new ways.</Trans>
                </div>
                <div
                  className="mx-auto flex flex-col
                  items-center text-center text-xs font-medium lg:text-sm"
                >
                  <Sprite name="empower" className="mb-2 h-9 w-14" />
                  <Trans>Empower your salespeople</Trans>
                </div>
                <div
                  className="mx-auto flex flex-col items-center 
                  text-center text-xs font-medium lg:text-sm"
                >
                  <Sprite name="retain" className="mb-2 h-9 w-10" />
                  <Trans>Retain your customers for life</Trans>
                </div>
              </div>
              <div
                className="flex flex-row items-center justify-center
                xxs:flex-col xxs:px-4 lg:px-20"
              >
                <button
                  id="cta_whoWeServe_expandIntoUntapped_getZbooni"
                  className="dark-green-gradient-btn w-full px-[30px]
									py-2 xxs:w-[250px] xs:w-[250px] md:w-[250px] md:px-6
									md:py-3 lg:w-[321px]"
                  onClick={() => setPopover(true)}
                >
                  <p>
                    <Trans>Get Zbooni</Trans>
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
